import React from 'react';
import { Box, Typography, List, ListItem, Avatar, Chip } from '@mui/material';
import { useCart } from '../context/CartContext';
import { formatMoney, getCasePrice } from '../utils/pricing';
import { getCaseQuantityDisplayText, getTotalItemCount, createCartItemId, calculateCustomCasePrice } from '../utils/caseQuantity';

const CheckoutItemSummary: React.FC = () => {
  const { cart } = useCart();

  if (!cart) return null;

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Your Items ({cart.items.length})
      </Typography>
      <List dense>
        {cart.items.map((item, index) => {
          const cartItemId = createCartItemId(item.productId, item.caseQuantity);
          const casePrice = item.isCustomCase 
            ? calculateCustomCasePrice(item.product, item.caseQuantity)
            : getCasePrice(item.product, item.caseQuantity);
          const totalPrice = casePrice * item.numberOfCases;
          const totalItems = getTotalItemCount(item.caseQuantity, item.numberOfCases);
          
          return (
            <ListItem key={cartItemId} divider>
            <Avatar 
              src={item.product.image_url || '/placeholder-product.png'} 
              variant="rounded" 
              sx={{ width: 40, height: 40, mr: 2 }} 
            />
            <Box sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography variant="body2" fontWeight="medium">
                  {item.product.name}
                </Typography>
                {item.isCustomCase && (
                  <Chip 
                    label="Custom" 
                    size="small" 
                    color="warning"
                    sx={{ height: 18, fontSize: '0.65rem' }}
                  />
                )}
              </Box>
              <Typography variant="body2" color="text.secondary">
                  {getCaseQuantityDisplayText(item.caseQuantity)} × {item.numberOfCases}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total: {totalItems} items
              </Typography>
            </Box>
            <Typography variant="body2" fontWeight="medium">
                {formatMoney(totalPrice)}
            </Typography>
          </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default CheckoutItemSummary; 